import React, { Component } from "react";

// import Swiper core and required modules
import SwiperCore, { Virtual, Navigation, Pagination, Autoplay } from "swiper";
import { Swiper } from "../../../node_modules/swiper/react/swiper";
import { SwiperSlide } from "../../../node_modules/swiper/react/swiper-slide";

import "../../../node_modules/swiper/swiper-bundle.css";

//Assets
import Demo from "../../Assets/demo.jpg";
import Starts from "../../Assets/starts.svg";

// install Swiper modules
SwiperCore.use([Navigation, Autoplay]);

export default class Testimonial extends Component {
  render() {
    return (
      <div className="Home_Testimonial">
        <div className="Home_TestimonialTitle">
          What Our User Say's About Us
        </div>
        <div className="Home_TestimonialCardsBlock">
          <Swiper
            slidesPerView={3}
            spaceBetween={0}
            navigation={true}
            grabCursor={true}
            loop={true}
            // autoplay={{
            //   delay: 2500,
            //   disableOnInteraction: false,
            // }}
            className="mySwiper"
          >
            {[...Array(10)].map(() => {
              return (
                <SwiperSlide>
                  <div className="Home_TestimonialCard">
                    <div className="Home_TestimonialCardImg">
                      <img src={Demo} alt="" />
                    </div>
                    <div className="Home_TestimonialCardInfo">
                      <div>Lokesh More</div>
                      <img src={Starts} alt="" />
                      <div>
                        Mellitus Care is a web-based application useful for a
                        user having diabetes. We helps our user to have a track
                        over their blood glucose and also suggest them for a
                        diet.
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    );
  }
}
